import { useEffect, useState } from "react";
import Lottie from "lottie-react";

interface Props {
  url: string;
  loop?: boolean;
}

export default function LottieFromS3({ url, loop = true }: Props) {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    let mounted = true;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (mounted) setAnimationData(data);
      })
      .catch(console.error);

    return () => {
      mounted = false;
    };
  }, [url]);

  if (!animationData) return null;

  return <Lottie animationData={animationData} loop={loop} />;
}
